import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../styles";

export const elementMultiPoints = style({
  fontSize: "1rem",
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      fontSize: vars.fontSizes.body.s,
    },
  },
});
